// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"8fc76078","161":"ce82a834","262":"52486e0f","266":"ee49272f","559":"08eb6a18","651":"e2b4c7ac"}[chunkId] + ".chunk.js";
};